import Vue from 'vue'
import Router from 'vue-router'
import Search from '@/views/Search'
import Login from '@/views/Login'
import UserAgreement from '@/views/UserAgreement'
import index from '@/views/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'search',
      component: Search
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: UserAgreement
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: "*",
      redirect: "/"
    },
  ]
})
